import cornerstone from "cornerstone-core";
// import cornerstone from 'cornerstone-tools'
import { useTranslation } from "react-i18next";

export const isValidNumber = (value) =>
	typeof value === "number" && !isNaN(value);

export const isValidDate = (formattedDate) => {
	if (!/^\d{8}$/.test(formattedDate)) return false;

	const year = +formattedDate.slice(0, 4);
	const month = +formattedDate.slice(4, 6) - 1;
	const day = +formattedDate.slice(6, 8);
	const date = new Date(year, month, day);

	return (
		date.getFullYear() === year &&
		date.getMonth() === month &&
		date.getDate() === day
	);
};

export const formatStudyDateIfValid = (studyDate) =>
	isValidDate(studyDate)
		? `${studyDate.slice(0, 4)}/${studyDate.slice(4, 6)}/${studyDate.slice(6, 8)}`
		: null;

export const formatTM = (time, strFormat = "HH:mm:ss") => {
	if (!time) {
		return;
	}
	// DICOM Time is stored as HHmmss.SSS, where:
	//      HH 24 hour time:
	//      m mm    0..59   Minutes
	//      s ss    0..59   Seconds
	//      S SS SSS    0..999  Fractional seconds
	//
	// Goal: '24:12:12'
	try {
		// Split to remove milliseconds (if present)
		const timePart = time.split('.')[0];
		// Validate and extract HH, MM, SS using regex
		const match = timePart.match(/^(\d{2})(\d{2})(\d{2})$/);
		if (!match) {
			throw new Error(`Invalid time format: Expected "HHmmss.SSS" but got "${time}"`);
		}
		// Return formatted time
		return strFormat
			.replace('HH', match[1])
			.replace('mm', match[2])
			.replace('ss', match[3])
	} catch (err) {
		// swallow?
		console.warn(err);
	}
};

export const formatPN = (name) => {
	if (!name) {
		return;
	}

	// Convert the first ^ to a ', '. String.replace() only affects
	// the first appearance of the character.
	const commaBetweenFirstAndLast = name.replace("^", ", ");

	// Replace any remaining '^' characters with spaces
	const cleaned = commaBetweenFirstAndLast.replace(/\^/g, " ");

	// Trim any extraneous whitespace
	return cleaned.trim();
};
export const formatDA = (date, strFormat = "MMM d, yyyy") => {
	if (!date) {
		return;
	}

	// Goal: 'Apr 5, 1999'
	try {
		const parsedDateTime = parse(date, "yyyyMMdd", new Date());
		const formattedDateTime = format(parsedDateTime, strFormat);

		return formattedDateTime;
	} catch (err) {
		// swallow?
	}
};

export const getFormattedStudyDate = (studyDate) => {
	const formattedDate = formatStudyDateIfValid(studyDate);

	return formattedDate;
};

export const formatNumberPrecision = (number, precision) => {
	if (number !== null) {
		return parseFloat(number).toFixed(precision);
	}
};

export const getCompression = (imageId) => {
	const { t } = useTranslation();

	const generalImageModule =
		cornerstone.metaData.get("generalImageModule", imageId) || {};
	const {
		lossyImageCompression,
		lossyImageCompressionRatio,
		lossyImageCompressionMethod,
	} = generalImageModule;

	if (lossyImageCompression === "01" && lossyImageCompressionRatio !== "") {
		const compressionMethod = lossyImageCompressionMethod || "Lossy: ";
		const compressionRatio = formatNumberPrecision(
			lossyImageCompressionRatio,
			2,
		);
		return `${compressionMethod + compressionRatio} : 1`;
	}

	return t("overlay.compression");
};
